/**
 * Mixpanel event names + super-property values for the new signup / creation flow
 * (branch feat/sign-in-flow-funnel).
 *
 * Names MUST stay lowercase and match the Mixpanel tracking plan exactly
 * (Desktop/Storydoc/SIGNUP_FUNNEL_ANALYTICS_PLAN.md) — the saved production
 * funnels/dashboards ([New Signup Flow]) key off these strings, so any drift
 * silently breaks them.
 */
export const SIGNUP_FLOW_EVENTS = {
  SELECT_SIGNUP_PROVIDER: "select signup provider",
  COMPLETE_SIGNUP: "complete signup",
  START_CREATION_FLOW: "start creation flow",
  SELECT_CREATION_METHOD: "select creation method",
  DETECT_EMAIL_DOMAIN: "detect email domain",
  COMPLETE_COMPANY_SETUP: "complete company setup",
  SELECT_DOCUMENT_TYPE: "select document type",
  SELECT_TEMPLATE: "select template",
  START_AI_GENERATION: "start ai generation",
  COMPLETE_AI_GENERATION: "complete ai generation",
  INSERT_INTERACTIVE_ELEMENT: "insert interactive element",
} as const;

/**
 * Super property stamped on every event fired within the new signup/creation
 * flow, so the Mixpanel funnels can filter to it (there is no A/B split — the
 * new flow is measured on its own tag + by date range).
 */
export const SIGNUP_FLOW_VERSION_PROP = "signup flow version";
export const SIGNUP_FLOW_VERSION = "how-to-start-2026";

export type SignupProvider = "google" | "microsoft" | "email";
export type CreationMethod = "ai" | "template" | "slides" | "blank";
